import clsx from 'clsx';
import React from 'react';

interface ButtonTextProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => any;
  className?: string;
  isDisabled?: boolean;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  isPrimary?: boolean;
  isDanger?: boolean;
}

const ButtonText = ({
  isPrimary,
  isDanger,
  className,
  label,
  onClick,
  isDisabled,
  style,
  ...other
}: ButtonTextProps) => {
  const classes = clsx('btn', 'is-link-button', isPrimary && 'color-primary', isDanger && 'color-danger', className);

  return (
    <button className={classes} style={style} disabled={isDisabled} onClick={onClick} type='button' {...other}>
      {label}
    </button>
  );
};

export default ButtonText;
